export default function loadJs(src) {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        document.head.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
    });
}
